import Skeleton from 'react-loading-skeleton'

import { css } from '~/styled-system/css'

export function Loading() {
  return (
    <>
      <div
        className={css({
          height: 'full',
          bg: 'gray.100',
          borderTop: '[4px solid]',
          borderColor: 'tertiary',
        })}
      >
        <div className={css({ spaceY: '4' })}>
          <div
            className={css({
              spaceY: '2',
              bg: 'white',
              px: { base: '3', _pc: '6' },
              py: { base: '4', _pc: '6' },
            })}
          >
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                spaceY: '2',
              })}
            >
              <Skeleton height={16} width={300} />
              <Skeleton height={14} width={151} />
              <Skeleton height={14} width={72} />
            </div>
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                spaceY: '2',
                rounded: 'md',
                border: 'medium',
                p: '3',
              })}
            >
              <Skeleton height={12} width={83} />
              <Skeleton height={13} width={151} />
              <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
                <Skeleton height={12} width={61} />
                <div className={css({ display: 'flex', flexDirection: 'column', spaceY: '1' })}>
                  <Skeleton height={15} width={61} />
                  <Skeleton height={10} width={61} />
                </div>
              </div>
            </div>
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                spaceY: '2',
                rounded: 'md',
                border: 'medium',
                p: '3',
              })}
            >
              <Skeleton height={12} width={60} />
              <div className={css({ display: 'flex', spaceX: '2' })}>
                <Skeleton height={68} width={68} />
                <div className={css({ display: 'flex', flexDirection: 'column', spaceY: '1' })}>
                  <Skeleton height={18} width={135} />
                  <Skeleton height={12} width={36} />
                  <Skeleton height={12} width={36} />
                </div>
              </div>
            </div>
          </div>
          <div
            className={css({
              spaceY: '3',
              bg: 'white',
              px: { base: '3', _pc: '6' },
              py: { base: '4', _pc: '6' },
            })}
          >
            <div className={css({ display: 'flex', flexDirection: 'column', spaceY: '5' })}>
              <div
                className={css({
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  spaceY: '3',
                })}
              >
                <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
                  <Skeleton height={16} width={80} />
                  <Skeleton height={12} width={91} />
                </div>
                <div className={css({ display: 'flex', flexDirection: 'column', spaceY: '1' })}>
                  <Skeleton height={14} width={196} />
                  <Skeleton height={14} width={79} />
                  <Skeleton height={14} width={94} />
                </div>
              </div>
              <Skeleton height={19} width={165} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
